import {
    NavigationState, Route,
} from '../../navigation/types'
import React, {useEffect} from 'react'

import {toast} from '../Toast'
import {useSelector} from 'react-redux'
import {useTranslation} from 'react-i18next'

const AuthorizationActivities = () => {
    const [previousRoute, setPreviousRoute] = React.useState<Route['name']>()
    const navigation = useSelector(({navigation: nav}: {navigation: NavigationState}) => nav)
    const {t} = useTranslation()

    /*
        Registration success toast need to be placed outside Register component because
        after success session_created event application is in authenticated state and Register component is automatically
        unmounted. This component exists outside private/public routes and can easily listen to route change Register -> Home
    */
    useEffect(() => {
        if (previousRoute === 'Register' && navigation.routes[navigation.position]?.name === 'Home') {
            toast.success(t('Account created'))
        }
        setPreviousRoute(navigation.routes[navigation.position]?.name)
    }, [navigation])

    return <div />
}

export default AuthorizationActivities
